



























import { defineComponent, ref } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SimpleDropdown from './SimpleDropdown.vue';
import IconButton from '../buttons/IconButton.vue';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		IconButton,
		SimpleDropdown,
	},
	props: {
		isMerged: Boolean,
	},
	setup() {
		const isDropdownOpen = ref(false);
		return {
			isDropdownOpen,
		};
	},
});
